<script setup lang="ts">
import { computed } from 'vue'
import { scoreToLevel, formatRiskScoreStr } from './shared'
import type { RiskConfig } from '@/models/api-generated'

const props = defineProps<{
	config?: RiskConfig
}>()

const model = defineModel<number>({ required: true })

const level = computed(() => scoreToLevel(model.value, props.config))
</script>

<template>
	<span class="badge" :style="'background-color: ' + level?.color" v-one-tooltip="level?.description">
		{{ formatRiskScoreStr(model, undefined, props.config) }} {{ level?.title }}
	</span>
</template>

<style lang="sass" scoped>
.badge
  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black
</style>
